"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD = void 0;
var entities_1 = require("@common/entities");
/** Same shape as {@link DEPOSIT_ALTERNATIVE_FIELD}; non-traditional option labeled for Third Party blocks. */
exports.DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD = [
    {
        label: 'Deposit Preference',
        type: entities_1.FieldType.Radio,
        customType: entities_1.FieldType.Radio,
        sequence: 1,
        name: 'selectedDepositOption',
        required: false,
        enabled: true,
        options: [
            { label: 'Third Party Deposit', value: entities_1.DepositOptionSelection.Base },
            { label: 'Traditional Deposit', value: entities_1.DepositOptionSelection.Traditional },
        ],
    },
];
